<template>
    <div class="cp-modal">
        <slot></slot>
    </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
    .cp-modal
        _center()
        position fixed
        z-index 3
</style>
<script>
  export default{
    beforeMount(){

    },
    methods: {

    },
    mounted(){
        
    }
  }
</script>

